const UIStrategy = require('./ui_strategy');
const UIStrategyDefault = require('./ui_strategy_default');
const UIStrategyPending = require('./ui_strategy_pending');

UIStrategy.factory = (bookingInfo, view, templates, keys, constants) => {
    let UIStrategyClass;

    const status = bookingInfo.bookingStatus;
    switch (status) {
        case 'CONTRACT':
        case 'INIT':
        case 'PENDING':
        case 'REJECTED':
        case 'DIDNOTBUY':
        default:
            UIStrategyClass = UIStrategyDefault;
            break;
        case 'HOLD':
        case 'REQUEST':
        case 'RETAINED':
            UIStrategyClass = UIStrategyPending;
            break;
    }

    return new UIStrategyClass(bookingInfo, view, templates, keys, constants);
};

module.exports = UIStrategy;
